module.exports = __webpack_public_path__ + "img/i-role-min1.fa890e27.png";